import { ExtensionBase } from "./extensionBase";
import { viewerOptions } from "../viewer";
import { UiUtils } from "../common/uiUtils";

/**
 * An extension that hides given Forge tools.
 */
export class ToolHiderExtension extends ExtensionBase {

    static extensionName = "ToolHiderExtension";

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
    }

    static registerExtension() {
        super.registerExtension(ToolHiderExtension.extensionName, ToolHiderExtension);
    }

    load(): boolean {
        console.log(`${ToolHiderExtension.extensionName} is loaded!`);
        return super.load();
    };

    onToolbarCreated(): void {
        window.setTimeout(() => viewerOptions.tools.hiddenTools.map(UiUtils.hideUiElement), 300);
    }
}